
import Navbar from '../visa-travel-tips/components/Navbar';
import Footer from '../visa-travel-tips/components/Footer';

export default function PackingChecklist() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-purple-600 to-pink-600 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Checklist chuẩn bị hành lý du lịch Mỹ
            </h1>
            <p className="text-xl text-purple-100 mb-8 max-w-3xl mx-auto">
              Hướng dẫn chi tiết chuẩn bị hành lý theo từng mùa và mục đích du lịch
            </p>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors">Trang chủ</a>
            <span>/</span>
            <a href="/visa-travel-tips" className="hover:text-teal-600 transition-colors">Kinh nghiệm du lịch</a>
            <span>/</span>
            <span className="text-gray-900 font-medium">Checklist hành lý</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-lg max-w-none">
          {/* Giấy tờ quan trọng */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-file-list-3-line text-purple-600"></i>
              Giấy tờ & Tài liệu quan trọng
            </h2>

            <div className="bg-gradient-to-r from-red-50 to-orange-50 rounded-xl p-8 mb-8">
              <div className="flex items-center gap-3 mb-6">
                <i className="ri-alert-line text-red-600 text-2xl"></i>
                <h3 className="text-xl font-bold text-red-800">Cực kỳ quan trọng - Không thể thiếu!</h3>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold mb-4 text-red-700">📋 Bắt buộc phải có:</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-red-600 mt-1"></i>
                      <div>
                        <strong>Hộ chiếu:</strong> Còn hạn trên 6 tháng
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-red-600 mt-1"></i>
                      <div>
                        <strong>Visa Mỹ:</strong> Bản gốc + photocopy
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-red-600 mt-1"></i>
                      <div>
                        <strong>Vé máy bay:</strong> In ra hoặc lưu offline
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-red-600 mt-1"></i>
                      <div>
                        <strong>Bảo hiểm du lịch:</strong> Bản tiếng Anh
                      </div>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold mb-4 text-orange-700">📄 Nên mang theo:</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-orange-600 mt-1"></i>
                      <div>
                        <strong>Booking khách sạn:</strong> Confirmation email
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-orange-600 mt-1"></i>
                      <div>
                        <strong>Lịch trình du lịch:</strong> Địa chỉ, liên hệ
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-orange-600 mt-1"></i>
                      <div>
                        <strong>Bằng lái xe:</strong> Quốc tế (IDP)
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-orange-600 mt-1"></i>
                      <div>
                        <strong>Thẻ tín dụng:</strong> 2-3 thẻ khác nhau
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6">
              <h4 className="font-semibold text-blue-800 mb-3">💡 Mẹo bảo quản giấy tờ</h4>
              <ul className="space-y-2 text-sm">
                <li>• Scan tất cả giấy tờ lưu trên cloud (Google Drive, Dropbox)</li>
                <li>• In 2 bản: 1 để hành lý ký gửi, 1 mang theo người</li>
                <li>• Chụp ảnh lưu trên điện thoại để dự phòng</li>
                <li>• Để trong túi chống thấm nước</li>
              </ul>
            </div>
          </section>

          {/* Quần áo theo mùa */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-shirt-line text-purple-600"></i>
              Quần áo theo mùa & vùng miền
            </h2>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div className="bg-blue-50 rounded-xl p-6">
                <h3 className="text-xl font-bold text-blue-900 mb-4 flex items-center gap-2">
                  <i className="ri-snowy-line"></i>
                  Mùa đông (12-2) - Bắc Mỹ
                </h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium mb-2">🧥 Áo khoác & Outerwear:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Down jacket (chống -20°C)</li>
                      <li>• Wool coat cho formal</li>
                      <li>• Rain jacket chống gió</li>
                      <li>• Sweater/hoodie 2-3 chiếc</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-medium mb-2">👕 Quần áo:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Thermal underwear</li>
                      <li>• Long sleeve shirts</li>
                      <li>• Jeans dày + legging</li>
                      <li>• Wool socks dày</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-yellow-50 rounded-xl p-6">
                <h3 className="text-xl font-bold text-yellow-900 mb-4 flex items-center gap-2">
                  <i className="ri-sun-line"></i>
                  Mùa hè (6-8) - Toàn Mỹ
                </h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium mb-2">👕 Quần áo mát:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• T-shirt cotton thoáng mát</li>
                      <li>• Shorts/skirts nhẹ</li>
                      <li>• Sundress cho nữ</li>
                      <li>• Linen shirts</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-medium mb-2">🏖️ Đi biển/hồ bơi:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Bikini/Swim trunks (2 bộ)</li>
                      <li>• Cover-up/sarong</li>
                      <li>• Flip flops</li>
                      <li>• Beach towel</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-orange-50 rounded-xl p-6">
                <h3 className="text-xl font-bold text-orange-900 mb-4 flex items-center gap-2">
                  <i className="ri-leaf-line"></i>
                  Thu/Xuân (3-5, 9-11)
                </h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium mb-2">🧥 Layer system:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Light jacket/cardigan</li>
                      <li>• Long sleeve + short sleeve</li>
                      <li>• Jeans + khakis</li>
                      <li>• Scarf nhẹ</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-green-50 rounded-xl p-6">
                <h3 className="text-xl font-bold text-green-900 mb-4 flex items-center gap-2">
                  <i className="ri-building-line"></i>
                  Business/Formal
                </h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium mb-2">👔 Trang phục công sở:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Suit 1-2 bộ</li>
                      <li>• Dress shirt trắng</li>
                      <li>• Cravat/nơ</li>
                      <li>• Dress shoes</li>
                      <li>• Belt matching shoes</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-purple-50 border-l-4 border-purple-500 p-6">
              <h4 className="font-semibold text-purple-800 mb-3">👟 Giày dép essential</h4>
              <div className="grid md:grid-cols-3 gap-4">
                <ul className="text-sm space-y-2">
                  <li><strong>Walking shoes:</strong> Comfortable, broken-in</li>
                  <li><strong>Sneakers:</strong> Cho hoạt động thể thao</li>
                </ul>
                <ul className="text-sm space-y-2">
                  <li><strong>Dress shoes:</strong> Cho formal events</li>
                  <li><strong>Sandals:</strong> Dép thoáng cho hè</li>
                </ul>
                <ul className="text-sm space-y-2">
                  <li><strong>Boots:</strong> Cho mùa đông/hiking</li>
                  <li><strong>Slippers:</strong> Đi trong khách sạn</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Đồ dùng cá nhân */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-user-heart-line text-purple-600"></i>
              Đồ dùng cá nhân & Sức khỏe
            </h2>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div className="bg-pink-50 rounded-lg p-6">
                <h4 className="font-semibold text-pink-900 mb-4">🧴 Skincare & Beauty</h4>
                <ul className="space-y-2 text-sm">
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-pink-600"></i>
                    <span>Sunscreen SPF 30+ (bắt buộc)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-pink-600"></i>
                    <span>Moisturizer (khí hậu khô)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-pink-600"></i>
                    <span>Cleanser travel size</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-pink-600"></i>
                    <span>Lip balm with SPF</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-pink-600"></i>
                    <span>Makeup basics</span>
                  </li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4">💊 Thuốc & Y tế</h4>
                <ul className="space-y-2 text-sm">
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-green-600"></i>
                    <span>Thuốc đang dùng + đơn thuốc</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-green-600"></i>
                    <span>Paracetamol/Ibuprofen</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-green-600"></i>
                    <span>Thuốc tiêu hóa</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-green-600"></i>
                    <span>Band-aids</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-green-600"></i>
                    <span>Thermometer</span>
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="font-semibold text-blue-900 mb-4">🦷 Vệ sinh cá nhân</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Bàn chải đánh răng + kem</li>
                  <li>• Shampoo/conditioner travel size</li>
                  <li>• Body wash</li>
                  <li>• Deodorant</li>
                  <li>• Nail clippers</li>
                  <li>• Hair styling products</li>
                </ul>
              </div>

              <div className="bg-yellow-50 rounded-lg p-6">
                <h4 className="font-semibold text-yellow-900 mb-4">👀 Phụ kiện cá nhân</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Kính mát UV protection</li>
                  <li>• Kính cận + kính dự phòng</li>
                  <li>• Contact lens + solution</li>
                  <li>• Đồng hồ + charger</li>
                  <li>• Jewelry minimal</li>
                </ul>
              </div>
            </div>

            <div className="bg-red-50 border border-red-200 rounded-lg p-6">
              <h4 className="font-semibold text-red-800 mb-3 flex items-center gap-2">
                <i className="ri-alert-line"></i>
                Lưu ý về thuốc men
              </h4>
              <ul className="space-y-2 text-sm">
                <li>• <strong>Thuốc theo toa:</strong> Mang đơn thuốc bằng tiếng Anh</li>
                <li>• <strong>Liquid medication:</strong> Dưới 100ml hoặc để hành lý ký gửi</li>
                <li>• <strong>Controlled substances:</strong> Cần giấy tờ chứng minh</li>
                <li>• <strong>Mang dư:</strong> Nhiều hơn số ngày đi 50% để dự phòng</li>
              </ul>
            </div>
          </section>

          {/* Đồ điện tử */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-smartphone-line text-purple-600"></i>
              Đồ điện tử & Công nghệ
            </h2>

            <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-8 mb-6">
              <div className="grid md:grid-cols-3 gap-6">
                <div>
                  <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-phone-line text-blue-600"></i>
                    Thiết bị cơ bản
                  </h4>
                  <ul className="space-y-2 text-sm">
                    <li>✅ Điện thoại + sạc</li>
                    <li>✅ Power bank 10,000mAh</li>
                    <li>✅ Adapter đa năng (Type A/C)</li>
                    <li>⭐ Laptop + charger</li>
                    <li>⭐ Tablet cho giải trí</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-camera-line text-green-600"></i>
                    Photography
                  </h4>
                  <ul className="space-y-2 text-sm">
                    <li>⭐ Camera + lens</li>
                    <li>⭐ Extra batteries</li>
                    <li>⭐ SD cards</li>
                    <li>⭐ Tripod mini</li>
                    <li>⭐ Camera bag</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-headphone-line text-purple-600"></i>
                    Entertainment
                  </h4>
                  <ul className="space-y-2 text-sm">
                    <li>✅ Headphones/earbuds</li>
                    <li>⭐ Kindle/e-reader</li>
                    <li>⭐ Portable speaker</li>
                    <li>⭐ Gaming device</li>
                    <li>⭐ Streaming dongle</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-yellow-50 rounded-lg p-6">
                <h4 className="font-semibold text-yellow-900 mb-4">🔌 Điện áp & Cắm điện</h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Điện áp Mỹ:</strong> 110-120V (VN: 220V)</li>
                  <li>• <strong>Loại cắm:</strong> Type A & B</li>
                  <li>• <strong>Cần adapter:</strong> Cho thiết bị VN</li>
                  <li>• <strong>Voltage converter:</strong> Cho thiết bị không dual voltage</li>
                </ul>
              </div>
              
              <div className="bg-indigo-50 rounded-lg p-6">
                <h4 className="font-semibold text-indigo-900 mb-4">📱 Apps cần thiết</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Google Maps (offline maps)</li>
                  <li>• Uber/Lyft cho di chuyển</li>
                  <li>• Google Translate</li>
                  <li>• Banking apps</li>
                  <li>• Airline apps</li>
                  <li>• Weather apps</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Hành lý xách tay vs ký gửi */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-luggage-cart-line text-purple-600"></i>
              Phân chia hành lý thông minh
            </h2>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-green-50 rounded-xl p-6 border-l-4 border-green-500">
                <h3 className="text-xl font-bold text-green-900 mb-4 flex items-center gap-2">
                  <i className="ri-handbag-line"></i>
                  Hành lý xách tay (7-10kg)
                </h3>
                
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-green-800 mb-2">🏆 Ưu tiên cao nhất:</h4>
                    <ul className="text-sm space-y-1 text-green-700">
                      <li>• Giấy tờ quan trọng</li>
                      <li>• Thuốc men cần thiết</li>
                      <li>• Đồ điện tử giá trị</li>
                      <li>• 1 bộ quần áo thay</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h4 className="font-medium text-green-800 mb-2">💼 Đồ dùng cần thiết:</h4>
                    <ul className="text-sm space-y-1 text-green-700">
                      <li>• Sạc điện thoại</li>
                      <li>• Snacks cho chuyến bay</li>
                      <li>• Entertaiment (sách, headphones)</li>
                      <li>• Cosmetics travel size</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 rounded-xl p-6 border-l-4 border-blue-500">
                <h3 className="text-xl font-bold text-blue-900 mb-4 flex items-center gap-2">
                  <i className="ri-suitcase-line"></i>
                  Hành lý ký gửi (23kg)
                </h3>
                
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-blue-800 mb-2">👕 Quần áo chính:</h4>
                    <ul className="text-sm space-y-1 text-blue-700">
                      <li>• Phần lớn quần áo</li>
                      <li>• Giày dép nặng</li>
                      <li>• Áo khoác dày</li>
                      <li>• Đồ lạnh/formal wear</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h4 className="font-medium text-blue-800 mb-2">🧴 Đồ dùng cá nhân:</h4>
                    <ul className="text-sm space-y-1 text-blue-700">
                      <li>• Toiletries size lớn</li>
                      <li>• Hair styling tools</li>
                      <li>• Quà lưu niệm dự kiến mua</li>
                      <li>• Đồ điện tử không quan trọng</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 bg-orange-50 border border-orange-200 rounded-lg p-6">
              <h4 className="font-semibold text-orange-800 mb-3">⚠️ Đồ cấm mang theo</h4>
              <div className="grid md:grid-cols-3 gap-4 text-sm">
                <div>
                  <strong className="text-orange-900">Xách tay:</strong>
                  <ul className="space-y-1 mt-2">
                    <li>• Liquid &gt; 100ml</li>
                    <li>• Sharp objects</li>
                    <li>• Lighter fluid</li>
                  </ul>
                </div>
                <div>
                  <strong className="text-orange-900">Ký gửi:</strong>
                  <ul className="space-y-1 mt-2">
                    <li>• Lithium batteries</li>
                    <li>• Flammable items</li>
                    <li>• Valuables</li>
                  </ul>
                </div>
                <div>
                  <strong className="text-orange-900">Cả hai:</strong>
                  <ul className="space-y-1 mt-2">
                    <li>• Explosive materials</li>
                    <li>• Toxic substances</li>
                    <li>• Radioactive items</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Checklist theo hoạt động */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-map-2-line text-purple-600"></i>
              Checklist theo hoạt động đặc biệt
            </h2>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4 flex items-center gap-2">
                  <i className="ri-mountain-line"></i>
                  Outdoor & Adventure
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>✓ Hiking boots chống nước</li>
                  <li>✓ Backpack 30-40L</li>
                  <li>✓ Rain gear/poncho</li>
                  <li>✓ Quick-dry clothing</li>
                  <li>✓ First aid kit</li>
                  <li>✓ Headlamp + batteries</li>
                  <li>✓ Insect repellent</li>
                  <li>✓ Portable water filter</li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="font-semibold text-blue-900 mb-4 flex items-center gap-2">
                  <i className="ri-building-2-line"></i>
                  Business Trip
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>✓ Business cards (tiếng Anh)</li>
                  <li>✓ Laptop + adapters</li>
                  <li>✓ Formal suits (2-3 bộ)</li>
                  <li>✓ Dress shoes</li>
                  <li>✓ Portfolio/briefcase</li>
                  <li>✓ Voice recorder</li>
                  <li>✓ Meeting materials</li>
                  <li>✓ Gift for hosts</li>
                </ul>
              </div>

              <div className="bg-pink-50 rounded-lg p-6">
                <h4 className="font-semibold text-pink-900 mb-4 flex items-center gap-2">
                  <i className="ri-camera-2-line"></i>
                  Photography Trip
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>✓ DSLR/Mirrorless + lenses</li>
                  <li>✓ Tripod carbon fiber</li>
                  <li>✓ ND filters</li>
                  <li>✓ Extra batteries (6-8 viên)</li>
                  <li>✓ Memory cards (64GB+)</li>
                  <li>✓ Lens cleaning kit</li>
                  <li>✓ Weather protection</li>
                  <li>✓ Laptop for editing</li>
                </ul>
              </div>

              <div className="bg-orange-50 rounded-lg p-6">
                <h4 className="font-semibold text-orange-900 mb-4 flex items-center gap-2">
                  <i className="ri-shopping-bag-2-line"></i>
                  Shopping Trip
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>✓ Empty suitcase/duffel bag</li>
                  <li>✓ Shopping list + sizes</li>
                  <li>✓ Price comparison apps</li>
                  <li>✓ Multiple credit cards</li>
                  <li>✓ Shipping materials</li>
                  <li>✓ Calculator for tax</li>
                  <li>✓ Foldable tote bags</li>
                  <li>✓ Weight scale portable</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Final checklist */}
          <section className="mb-12">
            <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-6 text-center">📋 Final Checklist trước khi đi</h2>
              <div className="grid md:grid-cols-3 gap-6">
                <div>
                  <h3 className="font-semibold mb-4 text-purple-100">1 tuần trước:</h3>
                  <ul className="space-y-2 text-sm text-purple-100">
                    <li>□ Check-in online</li>
                    <li>□ Print boarding pass</li>
                    <li>□ Confirm hotel booking</li>
                    <li>□ Exchange currency</li>
                    <li>□ Notify bank về travel</li>
                    <li>□ Charge all devices</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-4 text-purple-100">1 ngày trước:</h3>
                  <ul className="space-y-2 text-sm text-purple-100">
                    <li>□ Check weather forecast</li>
                    <li>□ Pack toiletries</li>
                    <li>□ Set out of office</li>
                    <li>□ Arrange airport transfer</li>
                    <li>□ Check flight status</li>
                    <li>□ Final weight check</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-4 text-purple-100">Ngày đi:</h3>
                  <ul className="space-y-2 text-sm text-purple-100">
                    <li>□ Double-check passport</li>
                    <li>□ Grab snacks</li>
                    <li>□ Phone fully charged</li>
                    <li>□ Lock house/apartment</li>
                    <li>□ Leave 3h trước domestic</li>
                    <li>□ Relax & enjoy!</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <div className="bg-gradient-to-r from-teal-500 to-cyan-500 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Cần hỗ trợ chuẩn bị hành lý?</h3>
            <p className="mb-6 text-teal-100">
              Chúng tôi có checklist chi tiết cho từng loại hình du lịch!
            </p>
            <div className="flex flex-col gap-3 max-w-md mx-auto">
              <button className="bg-white text-teal-600 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
                Tải checklist PDF miễn phí
              </button>
              <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg text-lg font-semibold border-2 border-white transition-colors whitespace-nowrap cursor-pointer">
                Tư vấn chuẩn bị cá nhân
              </button>
            </div>
          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}
